'use strict'
const wixCodeMessageTypes = require('../wixCodeMessageTypes')
const messageTypes = require('./messageTypes')
const {WorkersManager} = require('./WorkersManager')
const {getSubDomain} = require('../utils/getSubDomain')
const pmrpc = require('pm-rpc')
const {getQueryParams} = require('../utils/queryParams')
const PLATFORM_PUBLIC_API_PREFIX = 'viewer_platform_public_api_'
const REQUEST_API = 'REQUEST_API'

const queryParmas = getQueryParams()

const fixDomain = () => {
    try {
        window.document.domain = getSubDomain(window.document.domain)
    } catch (err) {
        console.error(err)
    }
}

fixDomain()


const requestAPIFromWorker = (sendMessageToViewer, {data: messageData, target}) => {
    const {appDefId, workerId} = messageData
    const appName = `${PLATFORM_PUBLIC_API_PREFIX + appDefId}_${workerId}`
    pmrpc.api.request(appName, {target})
        .then(api => {
            pmrpc.api.set(appName, api)
            sendMessageToViewer(messageData)
        })
}

const sendMessageToViewer = message => {
    const args = message.ports ? [message.data || message, '*', message.ports] : [message.data || message, '*']
    window.parent.postMessage.apply(window.parent, args)
}

const getMessageHandler = (msgIntent, msgType) => {
    let msgHandler
    switch (true) {
        case msgIntent === wixCodeMessageTypes.WIX_CODE_INTENT && msgType === REQUEST_API:
            msgHandler = requestAPIFromWorker.bind(this, sendMessageToViewer)
            break
        default:
            msgHandler = sendMessageToViewer
            break
    }
    return msgHandler
}

window.iframeWorkerMessages = []

window.parent.postMessage({type: 'IFRAME_LOADED'}, '*')

const isDebug = queryParmas.isDebug

const workersManager = new WorkersManager(queryParmas)
workersManager.setMessageFromWorkerHandler(message => {
    const messageIntent = message.data.intent
    const messageType = message.data.type

    if (isDebug) {
        const copy = JSON.parse(JSON.stringify(message.data))
        window.iframeWorkerMessages.push({direction: 'INCOMING', copy, timestamp: performance.now()})
    }

    const handle = getMessageHandler(messageIntent, messageType)
    handle(message)
})

window.addEventListener('message', (message, transfer) => {
    const contextId = message.data.__messageContextId

    switch (message.data.type) {
        case messageTypes.INIT:
            workersManager.init(contextId)
            break
        case messageTypes.TERMINATE:
            workersManager.terminate(contextId)
            break
        default:
            workersManager.messageToWorker(contextId, message, transfer)
    }
})
